// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0f98ad62","453":"06c464ff"}[chunkId] + ".chunk.js";
};